import type { BusinessPriceTier, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'businesses/price-tiers';

export function getPriceTiers(query: BusinessPriceTier.SearchQuery) {
    return api.get<Pagination<BusinessPriceTier>>(rootPath, query);
}

export function getPriceTier(id: number) {
    return api.get<BusinessPriceTier.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postPriceTier(data: BusinessPriceTier.CreateRequest) {
    return api.post<BusinessPriceTier>(rootPath, data);
}

export function putPriceTier(
    id: number,
    data: BusinessPriceTier.UpdateRequest
) {
    return api.put<BusinessPriceTier>(`${rootPath}/${id}`, data);
}

export function deletePriceTier({ id }: BusinessPriceTier.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
